import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "children"];
import { useContext } from 'react';
import styled from 'foundations-theming/utils';
import { TileContext } from './TileContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTileSection = styled.div.withConfig({
  displayName: "TileSection__StyledTileSection"
})(({
  $compact,
  $flush,
  theme,
  $cssStyles
}) => {
  return Object.assign({
    padding: $compact ? theme.space['500'] : theme.space['800'],
    '& + &': {
      paddingTop: 0
    },
    // replaces the `has--vertical-spacing` className styling
    '& > :last-child': {
      marginBottom: theme.space['0']
    }
  }, $flush && {
    paddingLeft: 0,
    paddingRight: 0
  }, $cssStyles);
});
export const TileSection = _ref => {
  let {
      flush = false,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    compact
  } = useContext(TileContext);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTileSection, Object.assign({
    $compact: compact,
    $flush: flush
  }, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};
TileSection.displayName = 'TileSection';